import { jsx as _jsx } from "react/jsx-runtime";
export const Container = ({ children, className }) => (_jsx("div", { className: `max-w-[700px] mx-auto my-0 flex flex-col overflow-x-hidden overflow-y-auto h-full px-[20px] ${className}`, children: children }));
